import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FormControl, InputLabel, FilledInput, FormHelperText, InputAdornment, IconButton } from '@mui/material';

export function PasswordField({
  name,
  labelKey,
  autoComplete,
  autoFocus = false,
  error,
}: {
  name: string;
  labelKey: string;
  autoComplete?: string;
  autoFocus?: boolean;
  error?: string;
}) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { t } = useTranslation();

  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  return (
    <FormControl
      variant="filled"
      margin="normal"
      fullWidth
      required
      autoFocus={autoFocus}
      error={error !== undefined}
      sx={{
        backgroundColor: 'primary.main',
        borderRadius: 'var(--mui-shape-borderRadius)',
        '& .MuiFormHelperText-root': {
          backgroundColor: '#fff',
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: '14px',
          paddingRight: '14px',
          borderEndEndRadius: '3px',
          borderEndStartRadius: '3px',
          boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
        },
        '& .Mui-error::before': {
          borderWidth: 'thick',
        },
      }}
    >
      <InputLabel sx={{ color: 'white', fontWeight: 'bold' }} htmlFor={name} style={{ color: 'white' }} shrink={true}>
        {t(labelKey)}
      </InputLabel>
      <FilledInput
        id={name}
        name={name}
        type={showPassword ? 'text' : 'password'}
        autoComplete={autoComplete}
        sx={{ color: 'white' }}
        inputProps={{ 'data-qa-element-id': `login-${name}-input` }}
        data-qa-element-id={`login-${name}-div`}
        endAdornment={
          <InputAdornment position="end">
            <IconButton tabIndex={-1} onClick={handleClickShowPassword}>
              {showPassword ? (
                <Visibility sx={{ color: 'white' }} fontSize="large" />
              ) : (
                <VisibilityOff sx={{ color: 'white' }} fontSize="large" />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      <FormHelperText data-qa-element-id={`changePassword-${name}-error-text`}>{error}</FormHelperText>
    </FormControl>
  );
}
